export default "__VITE_ASSET__NZ9bNOyR__";